<bit-dialog dialogSize="large">
  <span bitDialogTitle>
    {{ "assignToCollections" | vfo1I18n: "addToSharedFolder" }}
    <span class="tw-text-sm tw-normal-case tw-text-muted">
      {{ editableItemCount | pluralize: ("itemLower" | i18n) : ("itemsLower" | i18n) }}
    </span>
  </span>

  <div bitDialogContent>
    <assign-collections
      [params]="params"
      [submitBtn]="assignSubmitButton"
      (onCollectionAssign)="onCollectionAssign($event)"
      (editableItemCountChange)="editableItemCount = $event"
      (submitButtonTextChange)="submitButtonText = $event"
    ></assign-collections>
  </div>

  <ng-container bitDialogFooter>
    <button
      #assignSubmitButton
      form="assign_collections_form"
      type="submit"
      bitButton
      bitFormButton
      buttonType="primary"
    >
      {{ submitButtonText ?? ("assign" | vfo1I18n: "transferAndAdd") }}
    </button>
    <button type="button" bitButton buttonType="secondary" bitDialogClose>
      {{ "cancel" | i18n }}
    </button>
  </ng-container>
</bit-dialog>
